
export default {
  name: 'notice-panel',
  props: {
    value: { type: Boolean, default: false },
    landlordId: { type: [Number, String], default: null }
  },
  data: function () {
    return {
      tab: 'inbox',
      items: [],
      pickerOpen: false,
      monthPicked: false,
      year: null,
      month: null,
      yearFloor: 2000
    };
  },
  computed: {
    opened: function () {
      return this.value;
    },
    canAcknowledge: function () {
      return !this.landlordId;
    },
    showAck: function () {
      return this.tab === 'inbox' && this.canAcknowledge;
    },
    yearCeil: function () {
      return new Date().getFullYear() + 5;
    },
    monthLabel: function () {
      if (!this.year || !this.month) return '';
      return this.year + '/' + this.pad2(this.month) + '月';
    },
    prevYear: function () {
      if (!this.year || this.year - 1 < this.yearFloor) return null;
      return this.year - 1;
    },
    nextYears: function () {
      var list = [];
      if (!this.year) return list;
      var step;
      for (step = 1; step <= 3; step++) {
        var y = this.year + step;
        if (y > this.yearCeil) break;
        list.push(y);
      }
      return list;
    },
    prevMonths: function () {
      var list = [];
      if (!this.month) return list;
      var start = Math.max(1, this.month - 3);
      var m;
      for (m = start; m < this.month; m++) list.push(m);
      return list;
    },
    nextMonths: function () {
      var list = [];
      if (!this.month) return list;
      var end = Math.min(12, this.month + 3);
      var m;
      for (m = this.month + 1; m <= end; m++) list.push(m);
      return list;
    },
    shownItems: function () {
      if (this.tab !== 'history') return this.items || [];
      if (!this.year || !this.month) return [];
      var key = this.year + '-' + this.pad2(this.month);
      return (this.items || []).filter(function (item) {
        var raw = item && item.created_at ? String(item.created_at) : '';
        return raw.slice(0, 7) === key;
      });
    }
  },
  watch: {
    value: function (opened) {
      if (opened) {
        this.loadList();
      } else {
        this.pickerOpen = false;
        this.monthPicked = false;
        this.year = null;
        this.month = null;
      }
    },
    tab: function () {
      this.pickerOpen = false;
      if (this.value) {
        this.loadList();
      }
    }
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    pad2: function (n) {
      var v = Number(n);
      if (!isFinite(v)) return '00';
      return v < 10 ? '0' + v : String(v);
    },
    setTab: function (tab) {
      if (tab === 'history') this.ensureMonth(false);
      this.tab = tab;
    },
    onPanelClick: function () {
      if (this.pickerOpen) this.pickerOpen = false;
    },
    togglePicker: function () {
      this.ensureMonth(false);
      this.pickerOpen = !this.pickerOpen;
    },
    selectYear: function (year) {
      var y = Number(year);
      if (!isFinite(y) || y < this.yearFloor || y > this.yearCeil) return;
      this.year = y;
      this.monthPicked = true;
    },
    selectMonth: function (month) {
      var m = Number(month);
      if (!isFinite(m) || m < 1 || m > 12) return;
      this.month = m;
      this.monthPicked = true;
    },
    onPickerWheel: function (event) {
      var rect = event.currentTarget.getBoundingClientRect();
      var dir = event.deltaY > 0 ? 1 : -1;
      if (event.clientX - rect.left < rect.width / 2) {
        this.selectYear(this.year + dir);
      } else {
        this.selectMonth(this.month + dir);
      }
    },
    latestStamp: function () {
      var stamp = '';
      (this.items || []).forEach(function (item) {
        var raw = item && item.created_at ? String(item.created_at) : '';
        if (raw && (!stamp || raw > stamp)) stamp = raw;
      });
      return stamp;
    },
    ensureMonth: function (preferData) {
      if (this.monthPicked && this.year && this.month) return;
      var stamp = preferData ? this.latestStamp() : '';
      if (stamp.length >= 7) {
        this.year = parseInt(stamp.slice(0, 4), 10);
        this.month = parseInt(stamp.slice(5, 7), 10);
        return;
      }
      if (!this.year || !this.month) {
        var now = new Date();
        this.year = now.getFullYear();
        this.month = now.getMonth() + 1;
      }
    },
    close: function () {
      this.pickerOpen = false;
      this.$emit('input', false);
    },
    noticeWhen: function (item) {
      if (!item || !item.created_at) return '';
      var raw = String(item.created_at).trim();
      var matched = raw.match(/^(\d{4})[-/](\d{2})[-/](\d{2})(?:[ T](\d{2}):(\d{2}))?/);
      if (!matched) return raw;
      var text = matched[1] + '/' + matched[2] + '/' + matched[3];
      if (matched[4]) text += '/' + matched[4] + ':' + matched[5];
      return text;
    },
    loadList: function () {
      var t = this;
      var tab = this.tab;
      var endpoint = this.landlordId
        ? ('landlord/' + this.landlordId + '/notices')
        : 'landlord/notices';
      axios.get(endpoint, { params: { tab: tab } }).then(function (res) {
        if (t.tab !== tab) return;
        if (res.data.status == 1 && res.data.options && res.data.options.items) {
          t.items = res.data.options.items;
        } else {
          t.items = [];
          t.toast('読み込みに失敗しました');
        }
        if (tab === 'history') t.ensureMonth(true);
      }).catch(function () {
        if (t.tab !== tab) return;
        t.items = [];
        t.toast('読み込みに失敗しました');
        if (tab === 'history') t.ensureMonth(true);
      });
    },
    ack: function (item) {
      var t = this;
      if (!item || !item.id) return;
      axios.post('landlord/notices/read/' + item.id).then(function (res) {
        if (res.data.status == 1) {
          t.items = t.items.filter(function (row) {
            return row.id !== item.id;
          });
          t.$emit('unread-changed');
          t.$emit('acked', item);
        } else {
          t.toast('確認に失敗しました');
        }
      }).catch(function () {
        t.toast('確認に失敗しました');
      });
    }
  }
};
